import React, { Component } from "react";
import { connect } from "react-redux";
import { INVESTMENTS } from "../../../store/types";

import { FormatCurrency } from "../../home/currencyFormatter";
import Image from "../../Image";

class Investments extends Component {
  render() {
    const { investments, upComingSipDetails } = this.props;
    return (
      <div>
        <div className="appbar-div">
          {this.props.active === INVESTMENTS &&
            investments.length > 0 &&
            investments.slice(0, this.props.count).map((investment, index) => (
              <React.Fragment key={index}>
                <div className="investor-investments-container-title">
                  {investment.SchDesc} - {investment.plndesc}
                </div>
                <div className="investor-investments-sub-container">
                  <div>
                    <div className="investor-investments-text">Cost Value</div>
                    <div className="investor-investments-sub-text">
                      <FormatCurrency
                        value={
                          !!investment.CostValue
                            ? investment.CostValue.split(".")[0]
                            : 0
                        }
                      />
                      {!!investment.CostValue
                        ? `.${investment.CostValue.split(".")[1]}`
                        : `.00`}
                      {/* <FormatCurrency value={investment.CostValue} /> */}
                    </div>
                  </div>
                  <div>
                    <div className="investor-investments-text">
                      Current Value
                    </div>
                    <div className="investor-investments-sub-text">
                      <FormatCurrency
                        value={
                          !!investment.CurrentValue
                            ? investment.CurrentValue.split(".")[0]
                            : 0
                        }
                      />
                      {!!investment.CurrentValue
                        ? `.${investment.CurrentValue.split(".")[1]}`
                        : `.00`}
                    </div>
                  </div>
                  <div>
                    <div className="investor-investments-text">
                      Absolute Returns
                    </div>
                    <div className="investor-investments-sub-text">
                      {investment.GainPercent}{" "}
                      <Image
                        src={
                          investment.GainPercent.includes("-")
                            ? "/images/down_investors.svg"
                            : "/images/rise.png"
                        }
                        alt="rise"
                        style={{ height: 15 }}
                      />
                    </div>
                  </div>
                </div>
              </React.Fragment>
            ))}
          <div className="responsive-investments">
            {this.props.active !== INVESTMENTS && !!upComingSipDetails.length
              ? upComingSipDetails
                  .slice(0, this.props.count)
                  .map((sip, index) => (
                    <React.Fragment key={index}>
                      <div className="investor-investments-sub-container">
                        <div
                          style={{ padding: "5px 10px" }}
                          className="upcoming-sip-flex "
                        >
                          <div className="investor-investments-text">
                            Fund Name
                          </div>
                          <div className="investor-investments-sub-text">
                            {`${sip.schname}-${sip.plnname}`}
                          </div>
                        </div>
                        <div
                          style={{ padding: "5px 10px" }}
                          className="upcoming-sip-flex "
                        >
                          <div className="investor-investments-text">
                            Folio Number
                          </div>
                          <div className="investor-investments-sub-text">
                            {sip.accno}
                          </div>
                        </div>

                        <div
                          style={{ padding: "5px 10px" }}
                          className="upcoming-sip-flex "
                        >
                          <div className="investor-investments-text">
                            Sip Date
                          </div>
                          <div className="investor-investments-sub-text">
                            {sip.sipdt}
                          </div>
                        </div>

                        <div
                          style={{ padding: "5px 10px" }}
                          className="upcoming-sip-flex "
                        >
                          <div className="investor-investments-text">
                            Sip Start Date
                          </div>
                          <div className="investor-investments-sub-text">
                            {sip.sipstartdt}
                          </div>
                        </div>

                        <div
                          style={{ padding: "5px 10px" }}
                          className="upcoming-sip-flex "
                        >
                          <div className="investor-investments-text">
                            Sip End Date
                          </div>
                          <div className="investor-investments-sub-text">
                            {sip.sipenddt}
                          </div>
                        </div>
                        <div
                          style={{ padding: "5px 10px" }}
                          className="upcoming-sip-flex "
                        >
                          <div className="investor-investments-text">
                            Sip Amount
                          </div>
                          <div className="investor-investments-sub-text">
                            {!!sip.amt ? sip.amt : 0}
                          </div>
                        </div>

                        <div
                          style={{ padding: "5px 10px" }}
                          className="upcoming-sip-flex "
                        >
                          <div className="investor-investments-text">
                            Status
                          </div>
                          <div className="investor-investments-sub-text">
                            {sip.Status}
                          </div>
                        </div>
                      </div>
                    </React.Fragment>
                  ))
              : this.props.active !== INVESTMENTS && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      fontSize: 20,
                    }}
                  >
                    No Upcoming SIPs
                  </div>
                )}
          </div>
          <div className="mobile-aum-list">
            {this.props.active !== INVESTMENTS &&
            !!upComingSipDetails.length ? (
              upComingSipDetails
                .slice(0, this.props.count)
                .map((sip, index) => (
                  <InvestorTableCard
                    key={index}
                    Fund_Name={`${sip.schname}-${sip.plnname}`}
                    Folio_Number={sip.accno}
                    Sip_Date={sip.sipdt}
                    Sip_Start_Date={sip.sipstartdt}
                    Sip_End_Date={sip.sipenddt}
                    Sip_Amount={!!sip.amt ? sip.amt : 0}
                    Sip_Status={sip.Status}
                  />
                ))
            ) : (
              <div></div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default connect(({ investor }) => {
  const { investments, upComingSipDetails } = investor;
  return { investments, upComingSipDetails };
})(Investments);
export class InvestorTableCard extends Component {
  render() {
    const {
      Fund_Name,
      Sip_Amount,
      Sip_End_Date,
      Sip_Start_Date,
      Sip_Date,
      Folio_Number,
      Sip_Status,
    } = this.props;
    return (
      <div
        style={{
          background: "white",
          border: "1px solid rgba(211,211,211,0.3)",
          padding: "7px 10px",
          margin: "10px 0px",
        }}
      >
        <div
          style={{
            color: "#005DAC",
            fontSize: 14,
            paddingBottom: 5,
            borderBottom: "1px solid rgba(211,211,211,0.3)",
          }}
        >
          {Fund_Name}
        </div>

        <div style={{ display: "flex", padding: "8px 0px" }}>
          <div style={{ flexGrow: 1, flexBasis: 0 }}>
            <div style={{ fontSize: 12 }}>Folio Number</div>
            <div
              style={{
                fontSize: 13,
                color: "#194b7e",
              }}
            >
              {Folio_Number}
            </div>
          </div>
          <div style={{ flexGrow: 1, flexBasis: 0 }}>
            <div style={{ fontSize: 12 }}>Sip Date</div>
            <div
              style={{
                fontSize: 13,
                color: "#194b7e",
              }}
            >
              {Sip_Date}
            </div>
          </div>
        </div>
        <div style={{ display: "flex", padding: "8px 0px" }}>
          <div style={{ flexGrow: 1, flexBasis: 0 }}>
            <div style={{ fontSize: 12 }}>Sip Start Date</div>
            <div
              style={{
                fontSize: 13,
                color: "#194b7e",
              }}
            >
              {Sip_Start_Date}
            </div>
          </div>
          <div style={{ flexGrow: 1, flexBasis: 0 }}>
            <div style={{ fontSize: 12 }}>Sip End Date</div>
            <div
              style={{
                fontSize: 13,
                color: "#194b7e",
              }}
            >
              {Sip_End_Date}
            </div>
          </div>
        </div>
        <div style={{ display: "flex", padding: "8px 0px" }}>
          <div style={{ flexGrow: 1, flexBasis: 0 }}>
            <div style={{ fontSize: 12 }}>Sip Amount</div>
            <div
              style={{
                fontSize: 13,
                color: "#194b7e",
              }}
            >
              {Sip_Amount}
            </div>
          </div>
          <div style={{ flexGrow: 1, flexBasis: 0 }}>
            <div style={{ fontSize: 12 }}>Sip Status</div>
            <div
              style={{
                fontSize: 13,
                color: "#194b7e",
              }}
            >
              {Sip_Status}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
